import { getAmplitudeInstance } from '../amplitudeHelpers';
import FilterName from '../enums/FilterName';
import MapBaseLayer from '../enums/MapBaseLayer';
import MapOverlay from '../enums/MapOverlay';

type logExplorePOIViewViewedParams = {
  collections_applied?: string[];
  collections_available?: string[];
  filters_applied?: FilterName[];
  lat?: number;
  lng?: number;
  map_base_layer?: MapBaseLayer;
  map_overlay?: MapOverlay[];
  num_results_returned?: number;
  poi_id?: number;
  zoom_level?: number;
};

/**
 * After user taps POI on explore map view they are zoomed into a POI-focused view. Only trails that include that POI are displayed.
 * @param params - Attributes to log with the amplitude event
 * @param params.collections_applied - The name for the collections that were set when an action took place.
 * @param params.collections_available - List of strings containing the collections available to the user.
 * @param params.filters_applied - List of strings containing the filters applied by the user
 * @param params.lat - Map focus latitude
 * @param params.lng - Map focus longitude
 * @param params.map_base_layer - Name of tile base layer currently selected
 * @param params.map_overlay - The overlay currently applied to the map.
 * @param params.num_results_returned - The number of results returned to the user
 * @param params.poi_id - Unique identifier of poi tapped
 * @param params.zoom_level - Zoom level where user has panned
 */
const logExplorePOIViewViewed = (
  {
    collections_applied,
    collections_available,
    filters_applied,
    lat,
    lng,
    map_base_layer,
    map_overlay,
    num_results_returned,
    poi_id,
    zoom_level
  }: logExplorePOIViewViewedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'explore poi view viewed',
    {
      'collections applied': collections_applied,
      'collections available': collections_available,
      'filters applied': filters_applied,
      lat,
      lng,
      'map base layer': map_base_layer,
      'map overlay': map_overlay,
      'num results returned': num_results_returned,
      'poi id': poi_id,
      'zoom level': zoom_level
    },
    callback
  );
};

export default logExplorePOIViewViewed;
